<template>
    <div class="x-title-view clearfix">
        <el-button
            v-if="
                (config.hasReturn && showType === null) ||
                showType == PageType.DRAWER
            "
            :icon="ArrowLeftBold"
            @click="() => $emit('close')"
            link
            type="primary"
            style="float: left; width: 32px; height: 32px"
        >
            返回
        </el-button>
        <span style="line-height: 32px; padding-left: 20px">{{
            config.name
        }}</span>
        <div class="ml30">
            <x-button-group
                :config="getButtonConfig(config)"
                :data="queryParams"
                @click="clickHandler"
            ></x-button-group>
        </div>
        <div v-if="getShow()" class="help">
            <el-button @click="downloadHelp" type="primary">帮助文档</el-button>
        </div>
    </div>
</template>
<script setup>
import { getCurrentInstance, ref, watch } from "vue";
import {
    ArrowLeftBold,
    Upload,
    Document,
    Download,
    Close
} from "@element-plus/icons-vue";
import { ElNotification } from "element-plus";
import { useRouterCacheStore } from "../store/RouterCacheStore";
import PageType from "./PageType";
import XButtonGroup from "../components/base/XButtonGroup.vue";
import { useRoute } from "vue-router";
const route = useRoute();
const inst = getCurrentInstance();
const store = useRouterCacheStore();

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    data: { default: null },
    queryParams: { default: null },
    showType: { default: null },
    proxy: { default: null },

    pcode: { default: null }
});

defineEmits({
    click: null,
    close: null
});

const dataView = ref(null);
watch(
    () => props.config?.view,
    (value) => {
        dataView.value = value;
    },
    { immediate: true }
);

const getButtonConfig = (config) => {
    const conf = Object.assign({}, config);
    conf.align = "right";
    conf.buttons = getButtons(
        config.buttons,
        config.uploadOption,
        config.templateOption,
        config.downloadOption
    );
    return conf;
};

const getButtons = (buttons, uploadOption, templateOption, downloadOption) => {
    if (!buttons) buttons = [];
    if (uploadOption) {
        const uploadAction = uploadOption.action || uploadOption;
        buttons.push({
            name: uploadOption.name || "导入",
            icon: Upload,
            code: "UPLOAD",
            upload: uploadAction
        });
    }
    if (templateOption) {
        const templateAction = templateOption.action || templateOption;
        buttons.push({
            name: templateOption.name || "模板",
            icon: Document,
            code: "TEMPLATE",
            link: templateAction
        });
    }
    if (downloadOption) {
        const downloadAction = downloadOption.action || downloadOption;
        buttons.push({
            name: downloadOption.name || "导出",
            icon: Download,
            code: "DOWNLOAD",
            link: downloadAction
        });
    }
    if (props.showType == PageType.DIALOG) {
        buttons.push({ icon: Close, code: "CLOSE", link: "" });
    }
    return buttons.length ? buttons : null;
};

const clickHandler = (button) => {
    console.log("button.code", button.code);
    if (button.code == "CLOSE") inst.emit("close");
    if (button.code == "UPLOAD") {
        ElNotification({
            title: "提示",
            message: "上传成功！",
            type: "success"
        });
    } else inst.emit("click", button);
};
const getShow = () => {
   
    const regex = /\/(tat|ebk)/;
    const isSubstringPresent = regex.test(route.path);
    return isSubstringPresent;
};
const downloadHelp = () => {
    if (route.path.indexOf("tat")!=-1) {
        let url = "/files/爱婴考培后台用户测试主线v1.2-20240322.docx";
        const link = document.createElement("a");
        // 这里是将链接地址url转成blob地址，
        fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
                link.href = URL.createObjectURL(blob);
                // 下载文件的名称及文件类型后缀
                link.download =
                    "爱婴考培后台用户测试主线v1.2-20240322.docx";
                document.body.appendChild(link);
                link.click();
                //在资源下载完成后 清除 占用的缓存资源
                window.URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
            });
     
    }else{
        let url = "/files/爱婴电子书后台用户操作主线v0.0.1-20231128.docx";
        const link = document.createElement("a");
        // 这里是将链接地址url转成blob地址，
        fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
                link.href = URL.createObjectURL(blob);
                // 下载文件的名称及文件类型后缀
                link.download =
                    "爱婴电子书后台用户操作主线.docx";
                document.body.appendChild(link);
                link.click();
                //在资源下载完成后 清除 占用的缓存资源
                window.URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
            });
    }
};
</script>
<style scoped>
.x-title-view {
    background: #fff;
    padding: 14px;
    display: flex;
    align-items: center;
    position: relative;
}

.x-title-view >>> .el-button {
    margin: 0 !important;
}
.ml30 {
    margin-left: 30px;
}
.help {
    position: absolute;
    right: 20px;
}
</style>
